import type { QuickPromptChipsProps } from "../types";

export function QuickPromptChips({ prompts, onSelect }: QuickPromptChipsProps) {
  return (
    <div className="flex gap-3 overflow-x-auto pb-2">
      {prompts.map((prompt) => (
        <button
          key={prompt}
          type="button"
          onClick={() => onSelect(prompt)}
          className="whitespace-nowrap rounded-full border px-4 py-2.5 text-sm font-medium bg-card border-border text-foreground hover:bg-muted transition-colors"
        >
          {prompt}
        </button>
      ))}
    </div>
  );
}